import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from "vue";
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";
import { LocalMemory } from "../../utils/LocalMemory";
import { DialogHandler } from "./DialogHandler";
import { translation } from "../../lang/Translation";

export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialDialog',
  setup(__props) {

const t = translation;

/**
 * 動的ラベル
 */
const notRePlayTitle = t.to("再表示しない", "not_review");
const tutorialUrl = "../public/tutorials/ja/block_tutorial.html";
const dialogTitle = t.to("BLOCKVROCK チュートリアル", "tutorial_title");
const BLOCKLY_KEY = "dont_next_show_tutorial_blockly";
const isNotReShow = ref(true);

const dialogId = DialogHandler.tutorialDialogId;
onMounted(() => {
  const myModalEl = document.getElementById(dialogId);
  if (!myModalEl) return;
  DialogHandler.onHideDialog(dialogId, function () {
    const localData = LocalMemory.instance;
    localData.setDontTutorialShow(isNotReShow.value);
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    title: _unref(dialogTitle),
    "dialog-class": { 'modal-lg': true }
  }, {
    default: _withCtx(() => [
      _createElementVNode("iframe", {
        id: "in_frame",
        class: "mb-3",
        src: tutorialUrl,
        frameborder: "no",
        width: "100%",
        style: {"height":"60vh"},
        scrolling: "yes"
      }),
      _createTextVNode(" " + _toDisplayString(_unref(notRePlayTitle)) + " ", 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isNotReShow).value = $event)),
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, isNotReShow.value]
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})